import { useQuery } from 'react-query';
import { documentsService } from 'hq/services';
import { RenderDocumentResponse } from 'hq/services/documents-service.types';
import { QUERY_KEYS } from 'api/query-keys';

export const useRenderDocument = (documentId: string, options?: { enabled?: boolean }) => {
  return useQuery<RenderDocumentResponse, Error>(
    QUERY_KEYS.renderDocument(documentId),
    () => documentsService.renderDocument(documentId),
    {
      enabled: options?.enabled ?? true,
    }
  );
};
